import { Link, TextField as OffTextField, PrimaryButton, TextField } from "@fluentui/react";
import AddCircle from '@mui/icons-material/AddCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { AddInventoryTrimDialog } from "components/dialogs/addInventoryDialog/AddInventoryTrimDialog";
import { CreateCustomerDealDialog } from "components/dialogs/dealTrackerDialog/dealDialog/CreateCustomerDealDialog";
import { CustomerNotFoundDialog } from "components/dialogs/dealTrackerDialog/dealDialog/CustomerNotFoundDialog";
import { CustomerRecordConfirmDialog } from "components/dialogs/dealTrackerDialog/dealDialog/CustomerRecordConfirmDialog";
import { DealPageSaveNotification } from "components/dialogs/dealTrackerDialog/DealPageSaveNotification";
import { DealRecordFoundDialog } from "components/dialogs/dealTrackerDialog/DealRecordFoundDialog";
import { AddOneDaySaleAppraisalDialog } from "components/dialogs/dealTrackerDialog/oneDaySaleAppraisalDialog/AddOneDaySaleAppraisalDialog";
import { AddVehicleAppraisalDialog } from "components/dialogs/dealTrackerDialog/oneDaySaleAppraisalDialog/AddVehicleAppraisalDialog";
import { EditDealOneDaySaleDialog } from "components/dialogs/dealTrackerDialog/oneDaySaleAppraisalDialog/EditDealOneDaySaleDialog";
import { EditVehicleAppraisalDialog } from "components/dialogs/dealTrackerDialog/oneDaySaleAppraisalDialog/EditVehicleAppraisalDialog";
import { VehicleFoundDialog } from "components/dialogs/dealTrackerDialog/VehicleFoundDialog";
import CustomTable from "components/table/datatable/CustomTable";
import { alloneDaySaleDate, dealTabIndex, themeStyles, upComingSaleDate, userGroupId } from "constants/constants";
import masterDropdownValues from "constants/masterDropdownValues";
import { useFormik } from "formik";
import * as _ from "lodash";
import moment from "moment";
import { Dropdown as PRDropdown } from 'primereact/dropdown';
import { InputMask } from "primereact/inputmask";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CurrencyInput from 'react-currency-input-field';
import { Col, Row } from "react-grid-system";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AppState } from "store";
import { handleGetDealTracker } from "store/dealTracker/dealTracker.action";
import { handleGetLocations } from "store/locations/locations.action";
import { handleCreateAppraisalFormValue, handleGetOneDayAppraisalTable, handleGetOneDaySaleDate, handleGetOneDaySaleAppraisalById, HandleGetOneDaySaleNotes, HandleSaveOneDaySaleNotes, handleUpdateOneDaySaleAppraisal, handleSelectedOneDaySaleTradeIn, handleShowOnedaySaleWarning, handleAddOneDaySaleToDealTradeIn, handleDeleteOneDaySale } from "store/oneDaySale/oneDaySale.action";
import { convertUTCToLocalDateOnlyModified } from "utils/dateTimeFunctions";
import { currencyNegValFractionalFormat, validTenDigitPhone } from "utils/helperFunctions";
import * as Yup from "yup";
 import { handleGetSelectList } from "store/selectList/selectList.action";
import { HANDLE_GET_EMPLOYEES } from "store/employees/employees.types";
import { CONFIRMATION } from '../../constants/constants';

interface ParamTypes {
    appraisalId: string;
}


export const OneDaySaleAppraisalPage = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const dispatch = useDispatch();
    const appraisalBidders = useSelector((state: AppState) => state.selectList.appraisalBidders) as any;
    const emptyOneDayAppraisalData = { id: null, employeeId: "", date: "", rollback: "", acv: "" };
    const classes = themeStyles;
    const navigate = useNavigate();
    const [tradeInsNoteError, setTradeInsNoteError] = React.useState(false);
    const [tradeInsNote, setTradeInsNote] = React.useState(null);
    const [tradeInVehicleData, setTradeInVehicleData] = React.useState(null);
    const [appraisedtTableData, setAppraisedTableData] = useState([]);
    const [appraiserData, setAppraiserData] = useState([]);
    const [isAddOneDaySaleAppraisalDialog, setisAddOneDaySaleAppraisalDialog] = useState(false);
    const [appraisedData, setAppraisedData] = useState(emptyOneDayAppraisalData);
    const [notesList, setNotesList] = React.useState([]);
    const [diasbledealBtn, setDiasbledealBtnn] = useState(null);
    const locations = useSelector((state: AppState) => state.locations.locations) as any;
    const [cityDealerList, setCityDealerList] = React.useState([]);
    const [isInventorySearchDialog, setisInventorySearchDialog] = useState(false);
    const user = useSelector((state: AppState) => state.userProfile.userProfile);
    const [primaryLocation, setPrimaryLocation] = React.useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [editDealRecord, setEditDealRecord] = useState(false);
    const [isCustomerNoFound, setIsCustomerNoFound] = useState(false);
    const [isCustomerRecordConfirm, setIsCustomerRecordConfirm] = useState(false);
    const [isCustomerNewData, setIsCustomerNewData] = useState(false);
    const [isDealLocationCusNonData, setIsDealLocationCusNonData] = React.useState([]);
    const [isData, setIsData] = React.useState([]);
    const [isRetainData, setIsRetainData] = React.useState([]);
    const [dealID, setdealID] = useState(0);
    const [dealFoundDialogOpen, setDealFoundDialogOpen] = useState(false);
    const [isSaveNotification, setisSaveNotification] = useState(false);
    const [isInventoryTriDialog, setisInventoryTriDialog] = useState(false);
    const [isTradeInVehicleFoundDialog, setTradeInVehicleFoundDialog] = useState(false);
    const [vinforTrim, setvinforTrim] = React.useState(null);
    const [ymmforTrim, setymmforTrim] = React.useState(null);
    const [trimValues, settrimValues] = React.useState([]);
    const [commonServerError, setcommonServerError] = useState(null);
    const [recentDeal, setRecentDeal] = useState('');
    const [isEditVehicleDialog, setIsEditVehicleDialog] = useState(false);
    const [appraisalData, setAppraisalData] = useState(null);
    const [formikInitialValues, setFormikInitialValues] = useState<any>('');
    const location: any = useLocation();
    const params = useParams<ParamTypes | any>();
    const selectedOneDaySaleTradeIn = useSelector(
        (state: AppState) => state.oneDaySale.selectedOneDaySaleTradeIn
    );
    const oneDaySaleDate = useSelector(
        (state: AppState) => state.oneDaySale.oneDaySaleDate
    );
    const isShowWarnig = useSelector(
        (state: AppState) => state.oneDaySale.isShowWarnig
    );
    const menuToRoute = useSelector(
        (state: AppState) => state.oneDaySale.menuToRoute
    );

    useEffect(() => {
        const isAppraiser = user?.defaultGroups?.some(x => x.defaultGroupId === userGroupId.appraiser.key);
        if (appraisedtTableData.length) {
            if (isAppraiser) {
                const appraisal = appraisedtTableData.filter((val) => val.employee.id === user.id);
                setAppraiserData(appraisal);
            } else {
                setAppraiserData(appraisedtTableData)
            }
        } else {
            setAppraiserData([]);
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appraisedtTableData]);

    useEffect(() => {
        if (params.appraisalId)
            dispatch<any>(
                handleGetOneDaySaleAppraisalById({
                    id: params.appraisalId,
                    callback: (res) => {
                        if (res) {
                            setAppraisalData(res);
                            setAppraisalFormik(res);
                        } else {
                            setcommonServerError("Failed to fetch data");
                        }
                    },
                })
            );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.appraisalId]);

    useEffect(() => {
        if (isShowWarnig) {
            setisSaveNotification(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowWarnig]);


    useEffect(() => {
        dispatch<any>(handleGetSelectList("appraisalBidders", 1));
        dispatch<any>({ type: HANDLE_GET_EMPLOYEES, payload: { isActive: 1, role: "salesPerson" } });
    }, [dispatch]);

    const setAppraisalFormik = (data) => {
        let newObj: any = {
            'appraisalConditions': data?.appraisalConditions,
            'subjectToSee': data?.subjectToSee,
            'status': data?.status,
            'appraisalBidderId': data?.appraisalBidder?.id,
            'color': data?.color,
            'odo': data?.odo,
            'tag': data?.tag,
            'oneDaySaleId': data?.oneDaySale?.id,
            'customerName': data?.customerName,
            'customerPhoneNumber': data?.customerPhoneNumber,
            'salesPersonId': data?.salesPerson?.id,
            'locationId': data?.location?.id,
        }
        setFormikInitialValues(newObj);
        appraisalFormik.setValues(
            {
                ...appraisalFormik.values,
                ...newObj
            });
    };

    const [salesPersonList, setSalesPersonList] = useState([]);
    const employees = useSelector((state: AppState) => state.employees.employees) as any;
    const [isSavedSuccessfully, setIsSavedSuccessfully] = useState(false);
    useEffect(() => {
        if (params.appraisalId) {
            dispatch<any>(handleSelectedOneDaySaleTradeIn({ id: params.appraisalId }));
            getOneDaySaleNotesDetails();
            handleGetTradeInsDetail(params.appraisalId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.appraisalId]);

    useEffect(() => {
        if (selectedOneDaySaleTradeIn) {
            if (selectedOneDaySaleTradeIn.vehicle) {
                setTradeInVehicleData(selectedOneDaySaleTradeIn.vehicle);
            } else {
                setTradeInVehicleData(null);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOneDaySaleTradeIn]);

    const appraisal_columns = {
        "createdAt": "Date",
        "rollback": "Roll Back",
        "acv": "ACV",
        "empName": "Adjusted By",
    };


    const fetchSaleDate = useCallback(() => {
        dispatch(
            handleGetOneDaySaleDate({
                formData: {
                    page: 1,
                    limit: 1000,
                    dateOrder:upComingSaleDate.futureDate.key,
                    allSaleDate:alloneDaySaleDate.futurePastDate.key,
                    column: 'oneDaySale.saleDate',
                    sort: 'ASC',
                }
            })
        );
    }, [dispatch]);

    useEffect(() => {
        fetchSaleDate();
    }, [fetchSaleDate]);

    useEffect(() => {
        dispatch<any>(handleGetLocations());

        if (user?.roles?.some(item => item === "ROLE_EMPLOYEE") && user?.primaryLocationId) {
            setPrimaryLocation(user.primaryLocation.id);
        }
        setNotesList([]);
        setDiasbledealBtnn(false);
        setTradeInsNote(null);
        setTradeInsNoteError(false);
        setTradeInVehicleData(null);
        setDiasbledealBtnn(false);
        setAppraisedTableData([]);
        setFormikInitialValues(appraisalFormik.initialValues);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const getOneDaySaleNotesDetails = useCallback(() => {
        if (params.appraisalId) {
            dispatch<any>(
                HandleGetOneDaySaleNotes({
                    dealTradeInId: params.appraisalId,
                    callback: (res) => {
                        if (res)
                            setNotesList(res.results);
                        else
                            setcommonServerError("Failed to fetch data")
                    },
                })
            );
        }
    }, [params.appraisalId, setNotesList, dispatch]);// eslint-disable-next-line react-hooks/exhaustive-deps

    useEffect(() => {

        let list = [];
        if (locations?.results.length > 0) {
            locations.results.map((item: any) => {
                return list.push({ key: item.id, text: (item.legalName) })
            });
            setCityDealerList(list);
        }
    }, [locations])

    const handleAddViewDeal = () => {
        setIsOpen(true)
    }

    const handleViewDeal = useCallback(() => {
        const state = {
            pathfrom: window.location.pathname,
            tabIndex: dealTabIndex.tradeIns.key
        }
        navigate(`/${appraisalData?.deal.id}/dealtracker`, { state });
    }, [appraisalData, navigate]);

    useEffect(() => {
        if (oneDaySaleDate?.results?.results?.length && location.pathname === '/one_day_sale_appraisal') {
            const initialValues = appraisalFormik.initialValues;
            appraisalFormik.setValues(
                {
                    ...appraisalFormik.values,
                    'oneDaySaleId': oneDaySaleDate?.results?.results[0]?.id,
                }
            );
            initialValues['oneDaySaleId'] = oneDaySaleDate?.results?.results[0]?.id
            setFormikInitialValues(initialValues);
        }

    }, [oneDaySaleDate])// eslint-disable-line react-hooks/exhaustive-deps


    const handleDeleteAppraisal = () => {
        const tradeInId = selectedOneDaySaleTradeIn?.id || params.appraisalId;
        if (tradeInId) {
            dispatch<any>(handleDeleteOneDaySale({
                id: tradeInId,
                callback: (res, err) => {
                    if (res) {
                        setcommonServerError(null);
                        const state = location?.state;
                        if (location?.state?.pathfrom && (location?.state?.pathfrom !== location?.pathname)) {
                            navigate(location?.state?.pathfrom, { state });
                        } else {
                            navigate('/one_day_sale_workbook');
                        }
                    } else if (err) {
                        setcommonServerError('Failed to delete the appraisal.');
                        window.scrollTo(0, 0);
                    }
                }
            }));
        }
    }

    const appraisalFormik = useFormik({
        initialValues: {
            appraisalConditions: "",
            subjectToSee: "",
            customerPhoneNumber: "",
            status: 8,
            appraisalBidderId: "",
            color: "",
            odo: "",
            tag: "",
            oneDaySaleId: '',
            customerName: '',
            salesPersonId: '',
            locationId: '',
        },
        validationSchema: Yup.object({
            appraisalConditions: Yup.string(),
            subjectToSee: Yup.string(),
            customerPhoneNumber: Yup.string()
                .test("required", "Phone number is required", (val) => {

                    if (val === undefined)
                        return true;
                    return val.replace(/[^0-9]/g, '').length > 0
                })
                .test("len", "Invalid phone number", (val) => {
                    if (val === undefined)
                        return true;
                    return validTenDigitPhone(val)
                }).required("Phone number is required"),
            status: Yup.string().required("Status is required"),
            appraisalBidderId: Yup.string(),
            color: Yup.string(),
            odo: Yup.string(),
            locationId: Yup.string().required("Location is required"),
            salesPersonId: Yup.string(),
            customerName: Yup.string().required("Customer Name is required"),
            tag: Yup.string()
                .matches(/^\d*$/, "Tag must be a number")
                .max(10, "Tag number must be at most 10 digits")
                .required("Tag number required"),
            oneDaySaleId: Yup.string()
        }),
        onSubmit: (values) => {
            const data = {
                customerPhoneNumber: values.customerPhoneNumber.replace(/\D/g, ''),
                status: values.status,
                appraisalBidderId: Number(values.appraisalBidderId),
                tag: values.tag,
                oneDaySaleId: values.oneDaySaleId,
                customerName: values.customerName,
                locationId: values.locationId,
            }

            if (values.appraisalConditions) {
                data['appraisalConditions'] = values.appraisalConditions
            }
            if (values.subjectToSee !== '') {
                data['subjectToSee'] = values.subjectToSee
            }
            if (values.color) {
                data['color'] = values.color
            }
            if (values.odo) {
                data['odo'] = values.odo
            }
            if (values.salesPersonId) {
                data['salesPersonId'] = values.salesPersonId
            }
            if (selectedOneDaySaleTradeIn?.id) {
                dispatch<any>(handleUpdateOneDaySaleAppraisal({
                    id: selectedOneDaySaleTradeIn.id, data,
                    callback: (res) => {
                        if (res) {
                            setIsSavedSuccessfully(true);
                            setisSaveNotification(false);
                            setcommonServerError(null);
                            handleCancel();
                        }
                        else {
                            setcommonServerError("Failed to save data");
                            window.scrollTo(0, 0);
                        }

                    }
                }));
            } else {
                dispatch(
                    handleCreateAppraisalFormValue(
                        data,
                        (id) => {
                            if (id) {
                                setIsSavedSuccessfully(true);
                                setisSaveNotification(false);
                                setcommonServerError(null);
                                handleCancel();
                            } else {
                                setcommonServerError('Failed to Save the Data.');
                                window.scrollTo(0, 0);
                            }
                        }
                    )
                );
            }


        }
    });

    const isValidSale = useMemo(() => {

        if (selectedOneDaySaleTradeIn?.tag && selectedOneDaySaleTradeIn?.status && selectedOneDaySaleTradeIn?.oneDaySale
            && selectedOneDaySaleTradeIn?.location && selectedOneDaySaleTradeIn?.customerPhoneNumber && selectedOneDaySaleTradeIn?.customerName) {
            return true
        } else {
            return false
        }

    }, [selectedOneDaySaleTradeIn])


    const handleCancel = () => {
        const state = location?.state?.pathfrom === '/appraisals'?{}: location?.state;
    
        navigate('/one_day_sale_workbook', { state });
    }

    useEffect(() => {
        let sales = [];
        if (employees.results.length > 0) {
            employees.results.map((item: any) => {
                return sales.push({ id: item.id, text: (item.firstName + ' ' + item.lastName) })
            });
            setSalesPersonList(sales)
        }
    }, [employees]);

    const handleAppraisalFormikSumbit = () => {
        appraisalFormik.handleSubmit();
    }

    const handleAppraisalFormikDDChange = (e: { value: any, target: any }) => {
        appraisalFormik.setValues(
            {
                ...appraisalFormik.values,
                [e.target.id]: e.value,
            }
        );
    }

    const handlecustomerPhoneNumberChange = (e) => {
        appraisalFormik.setValues(
            {
                ...appraisalFormik.values,
                [e.target.id]: e.target.value
            }
        );
    };

    const handleDispatchWarning =async (isChange,showWarn,hasMenu)=>{
        await dispatch<any>(
            handleShowOnedaySaleWarning({
                hasChange: isChange,
                showWarning: showWarn,
                isMenu:hasMenu,
            })
        );
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            let isHasChange;
            const formUnchanged = _.isEqual(appraisalFormik.values, formikInitialValues);
            const notesFilledButUnsaved = tradeInsNote && tradeInsNote.length > 0;

            if (!formUnchanged || notesFilledButUnsaved) {
                isHasChange = true;
            } else {
                isHasChange = false;
            }
            
            if(!isShowWarnig){
                if (isHasChange) {
                    handleDispatchWarning(true, false, '');
                } else {
                    handleDispatchWarning(false, false, '');
                }
            }
        }, 100);

        return () => clearInterval(intervalId);
    }, [appraisalFormik.values, formikInitialValues,isShowWarnig, tradeInsNote]);// eslint-disable-line react-hooks/exhaustive-deps


    const saveOneDaySaleNotesDetails = () => {
        if (tradeInsNote && tradeInsNote.length > 0) {
            setisSaveNotification(false);
            setTradeInsNoteError(false);
            setTradeInsNote(null);
            if (isValidSale) {
                dispatch<any>(
                    HandleSaveOneDaySaleNotes({
                        details: {
                            notes: tradeInsNote,
                        },
                        callback: (response) => {
                            if (response) {
                                getOneDaySaleNotesDetails();
                                setisSaveNotification(false)
                            } else {
                                setcommonServerError("Failed to save data")
                                    ;
                            }
                        },
                    })
                );
            } else {
                setcommonServerError("Sale Date,Tag,Customer name,Customer phone,Status,Location are required")
            }

        } else {
            setTradeInsNoteError(true);
        }
    };

    const dateTradeInBodyTemplate = (rowData) => {
        const tradeInDate = rowData.createdAt ? convertUTCToLocalDateOnlyModified(rowData.createdAt) : '';

        return (
            <React.Fragment>
                <span className="p-column-title">Log</span>
                <div style={{ textAlign: "left" }}>
                    {tradeInDate}
                </div>
            </React.Fragment>
        );
    };

    const rollbackTradeInBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Roll Back</span>
                <div style={{ textAlign: "left" }}>
                    {currencyNegValFractionalFormat(rowData.rollback)}
                </div>

            </React.Fragment>
        );
    };

    const acrTradeInBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">AVC</span>
                <div style={{ textAlign: "left" }}>
                    {currencyNegValFractionalFormat(rowData.acv)}
                </div>

            </React.Fragment>
        );
    };

    const appraisalByTradeInBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Appraised By</span>
                <div style={{ textAlign: "left" }}>
                    {rowData.employee ? `${rowData.employee.firstName} ${rowData.employee.lastName}` : ''}
                </div>
            </React.Fragment>
        );
    };

    const handleAppraisalDialogDismiss = useCallback((id) => {
        setisAddOneDaySaleAppraisalDialog(false);
        if (selectedOneDaySaleTradeIn?.id) {
            handleGetTradeInsDetail(selectedOneDaySaleTradeIn?.id)
            dispatch<any>(
                handleGetOneDaySaleAppraisalById({
                    id: selectedOneDaySaleTradeIn?.id,
                    callback: (res) => { },
                })
            );
        }
    }, [selectedOneDaySaleTradeIn]);// eslint-disable-line react-hooks/exhaustive-deps


    const handleGetTradeInsDetail = (tradeInId) => {
        dispatch<any>(handleGetOneDayAppraisalTable(
            tradeInId,
            (error, res) => {
                if (error) {
                    setcommonServerError('Failed to Fetch Data.');
                } else {
                    setAppraisedTableData(res);
                }
            }
        ));


    };
    const navtoOpenAppraisedValueDialog = () => {
        setAppraisedData(emptyOneDayAppraisalData);
        setisAddOneDaySaleAppraisalDialog(true)
    };

    const handleNoteChange = (e, newValue) => {
        setTradeInsNote(newValue);
    }

    const handleAddVehicle = () => {
        setisInventorySearchDialog(true)
    }

    const handleAddDealTrackerDialogDismiss = (res) => {
        setIsOpen(false);
        if (res && res.id) {
            setIsData(res)
            setIsOpen(false);
            setEditDealRecord(true);
        } else if (typeof res === 'number') {
            setdealID(res)
            setDealFoundDialogOpen(true);
            setIsOpen(false);
        } else if (!res || !res.target) {
            setIsCustomerNoFound(true);
        }
    }

    const handleCreateDealTrackerDialogDismiss = (res) => {
        setEditDealRecord(false);
        if (res && res.id) {
            const state = {
                pathfrom: window.location.pathname,
                tabIndex: dealTabIndex.tradeIns.key
            }
            navigate(`/${res.id}/dealtracker`, { state });
        }
    }

    const handleConfirmCreateDealTrackerDialogDismiss = (res) => {
        setIsCustomerRecordConfirm(false);
        if (res && res.id) {
            const state = {
                pathfrom: window.location.pathname,
                tabIndex: dealTabIndex.tradeIns.key
            }

            navigate(`/${res.id}/dealtracker`, { state });
        }
    }

    const createNewCustomerDialog = () => {
        setIsData(null)
        setIsOpen(false);
        setIsCustomerNoFound(false);
        setEditDealRecord(true);
    };

    const SearchAgainDialog = () => {
        setIsRetainData(isDealLocationCusNonData)
        setIsCustomerNoFound(false);
        setIsOpen(true);
    };

    const handleRouteBeforeSave = (e: any) => {
        if (e === CONFIRMATION.YES) {
            if (isShowWarnig) {
                if (menuToRoute) {
                    navigate(menuToRoute);
                } else {
                    navigate('/one_day_sale_workbook');
                }
              
            } else {
                const state = location?.state;
                if (location?.state?.pathfrom !== location?.pathname ) {
                    navigate(location?.state?.pathfrom, { state });
                } else {
                    navigate('/one_day_sale_workbook');
                }
            }
            handleDispatchWarning(false,false,'');

        } else {
             handleDispatchWarning(true,false,'');
             setisSaveNotification(false);
            if (appraisalFormik.isValid && appraisalFormik.dirty) {
                appraisalFormik.handleSubmit();
            } else {
                setcommonServerError("Sale Date,Tag,Customer name,Customer phone,Status,Location are required")
            }
        }
    }

    const handleBack = () => {
        const formUnchanged = _.isEqual(appraisalFormik.values, formikInitialValues);
        const notesFilledButUnsaved = tradeInsNote && tradeInsNote.length > 0;

        if ((formUnchanged && !notesFilledButUnsaved) || isSavedSuccessfully) {
            const state = location?.state;
            if (location?.state?.pathfrom && (location?.state?.pathfrom !== location?.pathname)) {
                navigate(location?.state?.pathfrom, { state });
            } else {
                navigate('/one_day_sale_workbook');
            }

        } else {
            setisSaveNotification(true);
        }
    }

    const hanldeOpenStyleModal = ({ vin, trim, ymm }) => {
        // resetVinYmm();
        setisInventorySearchDialog(false);
        settrimValues(trim);
        setisInventoryTriDialog(true);
        if (vin) {
            setvinforTrim(vin);
        } else {
            setymmforTrim(ymm);
        }
    };

    const handleAddInventoryDialogDismiss = (vehicleId, vin) => {
        if (vehicleId && Number.isInteger(vehicleId)) {
            dispatch<any>(handleGetDealTracker({
                id: vehicleId, callback: (res) => {
                    setisInventorySearchDialog(false);
                    if (res) {
                        res["vin"] = vin;
                        setRecentDeal(res);
                        setTradeInVehicleFoundDialog(true);
                    } else {
                        setcommonServerError('Failed to Fetch Data.');
                    }
                }
            }));
        }
        setisInventorySearchDialog(false);
    }

    const handleFoundDialogDismiss = (msg) => {
        if (msg && (typeof msg === 'string' || msg instanceof String)) {
            setcommonServerError(msg);
        }
        setTradeInVehicleFoundDialog(false);
    };

    const trimDialogDismisss = (msg) => {
        setisInventoryTriDialog(false);
    }

    const handleEditVehicle = () => {
        setIsEditVehicleDialog(true);
    }


    const handleCloseWarning = () => {
        setisSaveNotification(false);
        handleDispatchWarning(true,false,'');
    }

    const handleAddDealTradeIn = () => {
        dispatch<any>(handleAddOneDaySaleToDealTradeIn({
            deal: isDealLocationCusNonData,
            callback: (response) => {
                if (response?.id) {
                    setIsDealLocationCusNonData([]);
                    setDealFoundDialogOpen(false);
                    const state = {
                        pathfrom: window.location.pathname,
                        tabIndex: dealTabIndex.tradeIns.key
                    }

                    navigate(`/${dealID}/dealtracker`, { state });
                }

            }
        }));
    }



    return (
        <>
            {isEditVehicleDialog ?
                <EditVehicleAppraisalDialog
                    onDismiss={() => { setIsEditVehicleDialog(false) }}
                    isOpen={isEditVehicleDialog}
                    addVehicleSectionIndex={() => { setIsEditVehicleDialog(false); setisInventorySearchDialog(true); }}
                />
                : null
            }
            {isSaveNotification ?
                <DealPageSaveNotification
                    onDismiss={handleCloseWarning}
                    handleRoute={(route) => handleRouteBeforeSave(route)}
                />
                : null
            }
            {isInventorySearchDialog ?
                <AddVehicleAppraisalDialog
                    onDismiss={handleAddInventoryDialogDismiss}
                    openTrimDialog={hanldeOpenStyleModal}
                    isvalidSale={isValidSale}
                /> : null}

            {isAddOneDaySaleAppraisalDialog ?
                <AddOneDaySaleAppraisalDialog
                    onDismiss={handleAppraisalDialogDismiss}
                    formData={appraisedData}
                    isvalidSale={isValidSale}
                />
                : null}
            {
                isTradeInVehicleFoundDialog ?
                    <VehicleFoundDialog
                        onDismiss={(msg) => handleFoundDialogDismiss(msg)}
                        recentDeal={recentDeal}
                        trimType={3}
                        isAppraisal={true}
                    /> : null
            }

            {isOpen && (
                <CreateCustomerDealDialog
                    isOpen={isOpen}
                    formData={(res: any) => { setIsDealLocationCusNonData(res); }}
                    retainData={isRetainData}
                    primaryLocation={primaryLocation}
                    onDismiss={(msg) => handleAddDealTrackerDialogDismiss(msg)}
                    isAppraisal={true}
                />
            )}

            {editDealRecord && (
                <EditDealOneDaySaleDialog
                    isOpen={editDealRecord}
                    dealData={isDealLocationCusNonData}
                    data={isData}
                    ConfirmData={(e: any) => { setIsCustomerNewData(e); setIsCustomerRecordConfirm(true); }}
                    onDismiss={(msg) => handleCreateDealTrackerDialogDismiss(msg)}
                />
            )}

            {isCustomerNoFound && (
                <CustomerNotFoundDialog
                    isOpen={isCustomerNoFound}
                    openEditDialog={createNewCustomerDialog}
                    openSearchDialog={SearchAgainDialog}
                    onDismiss={() => setIsCustomerNoFound(false)}
                />
            )}

            {isCustomerRecordConfirm && (
                <CustomerRecordConfirmDialog
                    isOpen={isCustomerRecordConfirm}
                    onDismiss={(msg) => handleConfirmCreateDealTrackerDialogDismiss(msg)}
                    newData={isCustomerNewData}
                    oldData={isData}
                    changeCustomerData={() => { setIsCustomerRecordConfirm(false); }}
                    confirmCustomerData={() => { setEditDealRecord(false); }}
                    isAppraisal={true}
                />
            )}
            {
                dealFoundDialogOpen && (<DealRecordFoundDialog
                    dealID={dealID}
                    onDismiss={() => setDealFoundDialogOpen(false)}
                    isAppraisal={true}
                    handleAddTradeIn={handleAddDealTradeIn}
                />)
            }
            {isInventoryTriDialog ?
                <AddInventoryTrimDialog
                    onDismiss={trimDialogDismisss}
                    trimValues={trimValues}
                    vin={vinforTrim}
                    ymm={ymmforTrim}
                    isAppraisal={true}
                    vehID={null}
                    trimType={3}
                />
                : null}
            <Row>
                <Col sm={12} md={12} xs={12} lg={12}>

                    <img
                        alt="Back"
                        key={"back"}
                        className={isMobile ? "backButton settings" : "top_menu_backBtn backButton settings back-nav-btn"}
                        onClick={handleBack}
                        src={`${require("assets/back_pagination.png")}`}
                    />
                </Col>
            </Row>
            {
                commonServerError ?
                    <Row><Col>
                        <p className="genericErrorColor text-left"><span>{commonServerError}</span></p>
                    </Col> </Row> : null
            }
            <div className="dealTracker-tradein" style={{ marginTop: "50px" }}>
                <Row>
                    <Col>
                        {
                            tradeInVehicleData ? <>
                                <Row className="readOnlyFieldRowHead">
                                    <Col>
                                        {
                                            tradeInVehicleData.vin ? <>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div>
                                                        <strong>{tradeInVehicleData.vin}</strong>
                                                    </div>
                                                </div>
                                            </> : null
                                        }
                                        <div className="font-color-1">
                                            {tradeInVehicleData.year} &nbsp;&nbsp; {tradeInVehicleData.make} &nbsp;&nbsp; {tradeInVehicleData.model} &nbsp;&nbsp; {tradeInVehicleData.style}
                                        </div>
                                    </Col>
                                    <Col>
                                        <PrimaryButton onClick={handleEditVehicle} > Edit Vehicle </PrimaryButton>

                                    </Col>
                                </Row>
                            </> :
                                <>
                                    <Row className="readOnlyFieldRowHead rowHeadPadding" >
                                        <Col>
                                            <PrimaryButton
                                                //disabled={!(user?.aggregatedDefaultPolicies ? user.aggregatedDefaultPolicies.find(element => element === (dealTrackerOperationPermissions.DEAL_TRADE_IN_ADD_VEHICLE?.toString())) : isUserMaster(user.roles))}
                                                onClick={handleAddVehicle}>Add Vehicle for Appraisal</PrimaryButton>
                                        </Col>
                                    </Row>
                                </>
                        }
                        <div>
                            <Row justify="center">
                                <Col>
                                    <div>
                                        {
                                            isMobile ?
                                                <>

                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">One Day Sale Date</label>
                                                            <PRDropdown
                                                                id="oneDaySaleId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.oneDaySaleId}
                                                                options={oneDaySaleDate?.results?.results?.length ? oneDaySaleDate?.results?.results?.map(date => ({
                                                                    key: date.id,
                                                                    text: convertUTCToLocalDateOnlyModified(date.saleDate)
                                                                })) : []}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                className="custom-p-dropdown textAlign-Vertical"
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.oneDaySaleId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.oneDaySaleId &&
                                                                    appraisalFormik.errors.oneDaySaleId.toString()
                                                                }
                                                            </span>
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <TextField
                                                                id="tag"
                                                                name="tag"
                                                                label="Tag#"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.tag}
                                                                //required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.tag &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.tag &&
                                                                    appraisalFormik.errors.tag.toString()
                                                                }
                                                            />
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <TextField
                                                                id="customerName"
                                                                name="customerName"
                                                                label="Customer Name"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.customerName}
                                                                //required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.customerName &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.customerName &&
                                                                    appraisalFormik.errors.customerName.toString()
                                                                }
                                                            />
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <TextField
                                                                id="customerPhoneNumber"
                                                                name="customerPhoneNumber"
                                                                label="Customer Phone"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.customerPhoneNumber}
                                                                //required={true}
                                                                onChange={handlecustomerPhoneNumberChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.customerPhoneNumber &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.customerPhoneNumber &&
                                                                    appraisalFormik.errors.customerPhoneNumber.toString()
                                                                }
                                                            />
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">Sales Person</label>
                                                            <PRDropdown
                                                                id="salesPersonId"
                                                                placeholder=""
                                                                options={salesPersonList}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="id"
                                                                className="custom-p-dropdown textAlign-Vertical"
                                                                autoComplete="off"
                                                                value={appraisalFormik.values.salesPersonId}

                                                                onBlur={appraisalFormik.handleBlur}
                                                            />

                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.salesPersonId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.salesPersonId &&
                                                                    appraisalFormik.errors.salesPersonId.toString()
                                                                }
                                                            </span>

                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">Status</label>
                                                            <PRDropdown
                                                                id="status"
                                                                placeholder=""
                                                                value={appraisalFormik.values.status}
                                                                options={masterDropdownValues.appraisalStatus}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.status &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.status &&
                                                                    appraisalFormik.errors.status.toString()
                                                                }
                                                            </span>
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">Location</label>
                                                            <PRDropdown
                                                                id="locationId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.locationId}
                                                                options={cityDealerList}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.locationId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.locationId &&
                                                                    appraisalFormik.errors.locationId.toString()
                                                                }
                                                            </span>
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace" justify="center">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">Subject to See</label>
                                                            <PRDropdown
                                                                id="subjectToSee"
                                                                placeholder=""
                                                                value={appraisalFormik.values.subjectToSee}
                                                                options={masterDropdownValues.subjectToSeeOptions}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.subjectToSee &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.subjectToSee &&
                                                                    appraisalFormik.errors.subjectToSee.toString()
                                                                }
                                                            </span>
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text required-Label">Higher Bidder</label>
                                                            <PRDropdown
                                                                id="appraisalBidderId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.appraisalBidderId}
                                                                options={appraisalBidders}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown textAlign-Vertical"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <label className="lbl-text">Odo</label>
                                                            <CurrencyInput
                                                                customInput={TextField}
                                                                // thousandSeparator={true}
                                                                id="odo"
                                                                name="odo"
                                                                //label="Odo"
                                                                className=" mainQValuPageSec"
                                                                decimalScale={0}
                                                                value={appraisalFormik.values.odo ? appraisalFormik.values.odo.replace(/,/g, '') : ""}
                                                                onValueChange={(e) => {
                                                                    appraisalFormik.setValues(
                                                                        {
                                                                            ...appraisalFormik.values,
                                                                           "odo": e?e:''
                                                                        }
                                                                    );
                                                                }}
                                                                onBlur={appraisalFormik.handleBlur}

                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.errors.odo &&
                                                                    appraisalFormik.errors.odo.toString()}
                                                            </span>
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>
                                                    <Row className="rowSpace btw-space">
                                                        <Col xs={12}>
                                                            <TextField
                                                                id="color"
                                                                name="color"
                                                                label="Color"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.color}
                                                                //required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.color &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.color &&
                                                                    appraisalFormik.errors.color.toString()
                                                                }
                                                            />
                                                        </Col>
                                                        <Col></Col>
                                                    </Row>

                                                </> :
                                                <>
                                                    <Row justify="center">
                                                        <Col>

                                                            <label className="lbl-text required-Label">One Day Sale Date</label>
                                                            <PRDropdown
                                                                id="oneDaySaleId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.oneDaySaleId}
                                                                options={oneDaySaleDate?.results?.results?.length ? oneDaySaleDate?.results?.results?.map(date => ({
                                                                    key: date.id,
                                                                    text: convertUTCToLocalDateOnlyModified(date.saleDate)
                                                                })) : []}
                                                                optionValue="key"
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                className="custom-p-dropdown textAlign-Vertical"
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.oneDaySaleId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.oneDaySaleId &&
                                                                    appraisalFormik.errors.oneDaySaleId.toString()
                                                                }
                                                            </span>
                                                            <TextField
                                                                id="tag"
                                                                name="tag"
                                                                label="Tag#"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.tag}
                                                                required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.tag &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.tag &&
                                                                    appraisalFormik.errors.tag.toString()
                                                                }
                                                            />

                                                            <TextField
                                                                id="customerName"
                                                                name="customerName"
                                                                label="Customer Name"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.customerName}
                                                                required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.customerName &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.customerName &&
                                                                    appraisalFormik.errors.customerName.toString()
                                                                }
                                                            />
                                                            <div className="ms-TextField root-155">
                                                                <div className="ms-TextField-wrapper">
                                                                    <label className="lbl-text required-Label">Customer Phone</label>
                                                                    <div style={{ width: '100%' }} className={appraisalFormik.touched.customerPhoneNumber &&
                                                                        appraisalFormik.errors.customerPhoneNumber ? "createDealRecord mask-FieldGroup ms-TextField-fieldGroup invalid-input" : " createDealRecord mask-FieldGroup ms-TextField-fieldGroup"}>
                                                                        <InputMask
                                                                            autoClear={false}
                                                                            required={true}
                                                                            id="customerPhoneNumber"
                                                                            name="customerPhoneNumber"
                                                                            mask="(999)999-9999"
                                                                            placeholder=""
                                                                            value={appraisalFormik.values.customerPhoneNumber}
                                                                            className="mask-TextField"
                                                                            onChange={handlecustomerPhoneNumberChange}
                                                                            onBlur={appraisalFormik.handleBlur}>
                                                                        </InputMask>
                                                                    </div>
                                                                    <span className="error-message">{
                                                                        appraisalFormik.touched && appraisalFormik.touched.customerPhoneNumber &&
                                                                        appraisalFormik.errors && appraisalFormik.errors.customerPhoneNumber &&
                                                                        appraisalFormik.errors.customerPhoneNumber.toString()
                                                                    }</span>
                                                                </div>
                                                            </div>
                                                            <label className="lbl-text ">Sales Person</label>
                                                            <PRDropdown
                                                                id="salesPersonId"
                                                                name="salesPersonId"
                                                                options={salesPersonList}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="id"
                                                                placeholder=""
                                                                autoComplete="off"

                                                                className="custom-p-dropdown textAlign-Vertical"
                                                                value={appraisalFormik.values.salesPersonId}

                                                                onBlur={appraisalFormik.handleBlur}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.salesPersonId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.salesPersonId &&
                                                                    appraisalFormik.errors.salesPersonId.toString()
                                                                }
                                                            </span>

                                                        </Col>
                                                        <Col>

                                                            <label className="lbl-text required-Label">Status</label>
                                                            <PRDropdown
                                                                id="status"
                                                                placeholder=""
                                                                value={appraisalFormik.values.status}
                                                                options={masterDropdownValues.appraisalStatus}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.status &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.status &&
                                                                    appraisalFormik.errors.status.toString()
                                                                }
                                                            </span>
                                                            <label className="lbl-text required-Label">Location</label>
                                                            <PRDropdown
                                                                id="locationId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.locationId}
                                                                options={cityDealerList}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.locationId &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.locationId &&
                                                                    appraisalFormik.errors.locationId.toString()
                                                                }
                                                            </span>
                                                            <label className="lbl-text">Subject to See</label>
                                                            <PRDropdown
                                                                id="subjectToSee"
                                                                placeholder=""
                                                                value={appraisalFormik.values.subjectToSee}
                                                                options={masterDropdownValues.subjectToSeeOptions}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="text"
                                                                optionValue="key"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.touched && appraisalFormik.touched.subjectToSee &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.subjectToSee &&
                                                                    appraisalFormik.errors.subjectToSee.toString()
                                                                }
                                                            </span>
                                                            <label className="lbl-text">Higher Bidder</label>
                                                            <PRDropdown
                                                                id="appraisalBidderId"
                                                                placeholder=""
                                                                value={appraisalFormik.values.appraisalBidderId}
                                                                options={appraisalBidders}
                                                                onChange={handleAppraisalFormikDDChange}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                // appendTo="self"
                                                                className="custom-p-dropdown textAlign-Vertical"
                                                                filter={false}
                                                                resetFilterOnHide={true}
                                                            />
                                                            <label className="lbl-text">Odo</label>
                                                            <CurrencyInput
                                                                customInput={TextField}
                                                                // thousandSeparator={true}
                                                                id="odo"
                                                                name="odo"
                                                                //label="Odo"
                                                                className=" mainQValuPageSec"
                                                                decimalScale={0}
                                                                value={appraisalFormik.values.odo ? appraisalFormik.values.odo.replace(/,/g, '') : ""}
                                                                onValueChange={(e) => {
                                                                    appraisalFormik.setValues(
                                                                        {
                                                                            ...appraisalFormik.values,
                                                                            "odo": e?e:''
                                                                        }
                                                                    );
                                                                }}
                                                                onBlur={appraisalFormik.handleBlur}

                                                            />
                                                            <span className="error-message">
                                                                {
                                                                    appraisalFormik.errors.odo &&
                                                                    appraisalFormik.errors.odo.toString()}
                                                            </span>
                                                            <TextField
                                                                id="color"
                                                                name="color"
                                                                label="Color"
                                                                placeholder=""
                                                                autoComplete="off"
                                                                className="mainQValuPageSec"
                                                                value={appraisalFormik.values.color}
                                                                //required={true}
                                                                onChange={appraisalFormik.handleChange}
                                                                onBlur={appraisalFormik.handleBlur}
                                                                errorMessage={
                                                                    appraisalFormik.touched && appraisalFormik.touched.color &&
                                                                    appraisalFormik.errors && appraisalFormik.errors.color &&
                                                                    appraisalFormik.errors.color.toString()
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                        }
                                        <Row className="center">
                                            <Col xs={12} >
                                                <OffTextField
                                                    id="appraisalConditions"
                                                    name="appraisalConditions"
                                                    label="Appraisal Conditions"
                                                    multiline
                                                    resizable={false}
                                                    className="full-width fullHeight"
                                                    value={appraisalFormik.values.appraisalConditions}
                                                    onChange={appraisalFormik.handleChange}
                                                    onBlur={appraisalFormik.handleBlur}
                                                    errorMessage={
                                                        appraisalFormik.touched.appraisalConditions &&
                                                        appraisalFormik.errors.appraisalConditions &&
                                                        appraisalFormik.errors.appraisalConditions.toString()
                                                    }
                                                />
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                        <Row justify="center">
                                            <Col>
                                                <div className={`${isMobile ? '' : 'datatable-filter-mobTable'} table-section`} >
                                                    {/* <div className="card  p-datatable-customers-list" > */}
                                                    <CustomTable
                                                        column_list={appraisal_columns}
                                                        data={appraiserData}
                                                        sortField="acv"
                                                        sortOrder={-1}
                                                        customTemplates={{
                                                            "createdAt": dateTradeInBodyTemplate,
                                                            "rollback": rollbackTradeInBodyTemplate,
                                                            "acv": acrTradeInBodyTemplate,
                                                            "empName": appraisalByTradeInBodyTemplate,
                                                        }}
                                                        emptyMessage="No data found."
                                                    />
                                                    {/* </div> */}
                                                    <div style={{ textAlign: "right", margin: "-20px 15px 10px" }}>
                                                        <Link
                                                            disabled={!selectedOneDaySaleTradeIn?.vehicle}
                                                            color="inherit"
                                                            onClick={navtoOpenAppraisedValueDialog}>
                                                            <AddCircle style={{ marginBottom: '-8px' }} className={classes.icon + " circle-icon "} />
                                                            Appraised Value
                                                        </Link>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div style={{ width: "auto", display: "flex" }}>
                                            <div style={{ width: "100%", margin: "20px 0px 20px 0px" }}>
                                                <div style={{ float: "left" }}>
                                                    {selectedOneDaySaleTradeIn?.lastAppraiser && (appraisalData?.deal ?

                                                        <PrimaryButton
                                                            className="addViewDealBut"
                                                            disabled={diasbledealBtn}
                                                            style={{ float: "left" }}
                                                            onClick={handleViewDeal}>View Deal Record
                                                        </PrimaryButton>

                                                        :

                                                        <PrimaryButton
                                                            className="addViewDealBut"
                                                            disabled={diasbledealBtn}
                                                            style={{ float: "left" }}
                                                            onClick={handleAddViewDeal}>Add to Deal Record
                                                        </PrimaryButton>
                                                    )}
                                                </div>

                                                <div style={{ float: "right" }} className="appraisalDeleteBtn">
                                                    {params.appraisalId && (
                                                        <PrimaryButton
                                                            style={{ marginLeft: '5px', marginRight: '5px' }}
                                                            className="deleteDialogDelBut"
                                                            onClick={handleDeleteAppraisal}
                                                        >
                                                            Delete Appraisal
                                                        </PrimaryButton>
                                                    )}
                                                    <PrimaryButton style={{ marginRight: '5px' }} className="tradeInCancelBtn" onClick={handleBack}>Cancel</PrimaryButton>
                                                    <PrimaryButton
                                                        onClick={handleAppraisalFormikSumbit}
                                                        disabled={!appraisalFormik.dirty || !appraisalFormik.isValid}
                                                    >
                                                        Save
                                                    </PrimaryButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <Row>
                                <Col>
                                    <Accordion className="inventory-filter-accordion" defaultExpanded>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1c-content"
                                            id="panel1c-header"
                                        >
                                            <div className={classes.column + " notesdiv-pad writeUpsFont "} >
                                                <Typography component={'h3'} >Notes</Typography>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails >
                                            <Row>
                                                <Col className="notesSection">
                                                    <OffTextField
                                                        id="tradeInsNote"
                                                        name="tradeInsNote"
                                                        label=""
                                                        multiline
                                                        resizable={false}
                                                        className="full-width fontWeightSection"
                                                        style={{ fontSize: "14px", fontWeight: 600 }}
                                                        value={tradeInsNote}
                                                        onChange={(e, newValue) => handleNoteChange(e, newValue)}
                                                    />
                                                </Col>
                                            </Row>
                                            {
                                                tradeInsNoteError ?
                                                    <div className="">
                                                        <Row>
                                                            <Col>
                                                                <span className="genericErrorColor"><span>Please enter details</span></span>
                                                            </Col>
                                                        </Row>
                                                    </div> : null
                                            }

                                            <Row className="rowPaddingBtwSpace">
                                                <Col className="text-right">
                                                    <PrimaryButton style={{ marginTop: 10 }} onClick={() => saveOneDaySaleNotesDetails()}>Add Note</PrimaryButton>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <h3 style={{ border: "none" }} className="writeUpsFont">History</h3>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <hr />
                                                    {notesList?.map((item) => (

                                                        <div key={"boxes-" + item.id}>
                                                            <Row className="rowSpaceNotes rowSpace" style={{ padding: "0 20px" }}>
                                                                <Col md={3} xs={4}>
                                                                    <div className="writeUpsNoteText">{moment(new Date(item.createdAt)).local().format("MM/DD/YYYY").toString()}</div>
                                                                    <div className="writeUpsNoteText">{item?.employee.firstName} {item?.employee.lastName}</div>
                                                                </Col>
                                                                <Col md={6} xs={4} className="writeUpsNoteText">{item.notes}</Col>
                                                            </Row>
                                                            <hr />
                                                        </div>
                                                    ))}
                                                </Col>
                                            </Row>
                                        </AccordionDetails>
                                    </Accordion>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

